<template>
	<div class="tabela-margin">
		<!-- Filtro -->
		<div class="row" v-show="exibirFiltro">
			<div class="col-xs-12 col-md-2 form-group">
				<div class="btn-group btn-block">
					<button
						type="button"
						class="btn btn-default btn-sm btn-block dropdown-toggle"
						data-toggle="dropdown"
						aria-haspopup="false"
						aria-expanded="false"
					>
						<i class="fa fa-fw fa-filter" aria-hidden="true"></i>
						{{ _traducao('global', 'filtro').toUpperCase() + ' ' }}
						<span class="caret"></span>
					</button>

					<ul
						class="dropdown-menu tabela-ul"
						:style="{'max-height': _height - 140 + 'px'}"
					>
						<li :class="{active: filtroTodosAtivo}">
							<a @click.prevent.stop="clickFiltroTodos" href="#">{{
								_traducao('global', 'todos').toUpperCase()
							}}</a>
						</li>
						<template v-for="(dados, coluna) in colunasFiltroFormated">
							<label
								class="label label-filtro label-info"
								:key="'label:' + coluna"
								>{{ labelColuna(coluna).toUpperCase() }}</label
							>
							<li
								role="separator"
								class="divider"
								:key="'separator:' + coluna"
							></li>
							<li
								v-for="(valorColuna, key) in dados"
								:key="coluna + ':' + valorColuna + ':' + key"
								:class="{active: filtroAtivo(coluna, valorColuna)}"
							>
								<a
									@click.prevent.stop="clickFiltro(coluna, valorColuna)"
									href="#"
								>
									<span v-if="getColuna(coluna) && getColuna(coluna).binaria">{{
										valorColuna | transformaColunaBinaria
									}}</span>
									<span
										v-else-if="getColuna(coluna) && getColuna(coluna).numerica"
										>{{ valorColuna | transformaColunaNumberica }}</span
									>
									<span
										v-else-if="getColuna(coluna) && getColuna(coluna).data"
										>{{ valorColuna | transformaColunaData }}</span
									>
									<span
										v-else-if="getColuna(coluna) && getColuna(coluna).telefone"
										>{{ formatPhoneNumber(valorColuna) }}</span
									>
									<span
										v-else-if="getColuna(coluna) && getColuna(coluna).data_hora"
										>{{ valorColuna | transformaColunaDataHora }}</span
									>
									<span
										v-else-if="
											getColuna(coluna) && getColuna(coluna).porcentagem
										"
										>{{ valorColuna | transformaColunaPorcentagem }}</span
									>
									<span
										v-else-if="getColuna(coluna) && getColuna(coluna).hora"
										>{{ valorColuna | transformaColunaHora }}</span
									>
									<span
										v-else-if="
											getColuna(coluna) && getColuna(coluna).personalizado
										"
										>{{ getColuna(coluna).callback(valorColuna) }}</span
									>
									<span v-else>{{ valorColuna }}</span>
								</a>
							</li>
						</template>
					</ul>
				</div>
			</div>
		</div>
		<div class="row" v-show="exibirFiltro">
			<div class="col-xs-12">
				<div v-for="(filtrosColuna, coluna) in filtros" :key="coluna">
					<div
						cla
						v-for="(filtro, indexFiltro) in filtrosColuna"
						:key="indexFiltro"
					>
						<div
							class="label-filtro-lista label-info"
							@click="removeFiltro(coluna, indexFiltro)"
							style="float: left; margin-right: 10px"
						>
							<span v-if="getColuna(coluna) && getColuna(coluna).binaria">{{
								filtro | transformaColunaBinaria
							}}</span>
							<span
								v-else-if="getColuna(coluna) && getColuna(coluna).numerica"
								>{{ filtro | transformaColunaNumberica }}</span
							>
							<span v-else-if="getColuna(coluna) && getColuna(coluna).data">{{
								filtro | transformaColunaData
							}}</span>
							<span
								v-else-if="getColuna(coluna) && getColuna(coluna).telefone"
								>{{ formatPhoneNumber(filtro) }}</span
							>
							<span
								v-else-if="getColuna(coluna) && getColuna(coluna).data_hora"
								>{{ filtro | transformaColunaDataHora }}</span
							>
							<span
								v-else-if="getColuna(coluna) && getColuna(coluna).porcentagem"
								>{{ filtro | transformaColunaPorcentagem }}</span
							>
							<span v-else-if="getColuna(coluna) && getColuna(coluna).hora">{{
								filtro | transformaColunaHora
							}}</span>
							<span
								v-else-if="getColuna(coluna) && getColuna(coluna).personalizado"
								>{{ getColuna(coluna).callback(filtro) }}</span
							>
							<span v-else>{{ filtro }}</span>
							<i class="fa pull-right fa-fw fa-times"></i>
						</div>
					</div>
				</div>
			</div>
		</div>

		<slot name="search-bar"></slot>

		<div class="row">
			<div
				:class="{'col-xs-9': exibeNovo, 'col-xs-12': !exibeNovo}"
				v-show="exibeBusca"
			>
				<i class="fa fa-search icone-busca" aria-hidden="true"></i>
				<input
					type="text"
					style="padding-left: 22px; margin-top: 7px; margin-bottom: 6px"
					:placeholder="inputBuscaPlaceholder"
					v-model="busca"
					@input="buscaServeSide"
					class="form-control"
				/>
			</div>

			<div class="col-xs-3" v-show="exibeNovo">
				<button
					@click.prevent="clickNovo()"
					class="btn btn-default btn-block"
					style="margin-top: 6px"
				>
					{{ textoNovo ? textoNovo : _traducao('global', 'novo') }}
				</button>
			</div>
		</div>

		<!-- Tabela -->
		<div class="row">
			<div class="col-sm-12 tabela-margin-top" :key="atualizaTabela">
				<div class="table-responsive">
					<table class="table table-lista table-striped table-hover">
						<thead>
							<tr>
								<th
									v-for="coluna in colunasTabela"
									:key="coluna.campo"
									:style="coluna.numerica ? 'text-align: right' : ''"
									:class="coluna.class"
								>
									<div v-if="coluna.naoOrdenar">
										<small style="color: white">{{ coluna.nome }}</small>
									</div>
									<div
										v-else
										@click.prevent="clickOrdenar(coluna.campo)"
										style="display: flex; align-items: center; cursor: pointer"
									>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											fill="none"
											viewBox="0 0 24 24"
											stroke-width="1.5"
											stroke="currentColor"
											style="width: 18px; heigth: 18px; margin-left: -6px"
											v-show="ordenacao.coluna != coluna.campo"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
											/>
										</svg>
										<svg
											v-show="
												ordenacao.coluna == coluna.campo &&
												ordenacao.sentidoCrescente
											"
											xmlns="http://www.w3.org/2000/svg"
											fill="none"
											viewBox="0 0 24 24"
											stroke-width="1.5"
											stroke="currentColor"
											style="width: 18px; heigth: 18px; margin-left: -6px"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												d="M15.75 17.25L12 21m0 0l-3.75-3.75M12 21V3"
											/>
										</svg>
										<svg
											v-show="
												ordenacao.coluna == coluna.campo &&
												!ordenacao.sentidoCrescente
											"
											xmlns="http://www.w3.org/2000/svg"
											fill="none"
											viewBox="0 0 24 24"
											stroke-width="1.5"
											stroke="currentColor"
											style="width: 18px; heigth: 18px; margin-left: -6px"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												d="M8.25 6.75L12 3m0 0l3.75 3.75M12 3v18"
											/>
										</svg>

										<small style="color: white; margin-top: 2px">{{
											coluna.nome
										}}</small>
									</div>
								</th>
								<th
									v-if="
										exibeConcluir ||
										exibeEditar ||
										exibeVisualizarImpressao ||
										exibeParecer ||
										exibeExcluir ||
										exibeCancelar ||
										exibeAtualizar
									"
									class="text-center"
								>
									<div
										style="display: flex; align-items: center; cursor: pointer"
									>
										<small style="color: white; margin-top: 2px">{{
											_traducao('global', 'opcoes')
										}}</small>
									</div>
								</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(itemTabela, indexItemTabela) in dadosTabelaPaginaAtual"
								:key="indexItemTabela"
								:class="condicaoLinha(itemTabela)"
							>
								<td
									v-for="coluna in colunasTabela"
									:key="coluna.campo"
									:style="coluna.numerica ? 'text-align: right' : ''"
									:class="coluna.class"
									style="vertical-align: middle"
								>
									<div style="font-size: 10px">
										<slot
											:name="'campo-' + coluna.campo"
											:campo="itemTabela[coluna.campo]"
											:item="itemTabela"
											:index="indexItemTabela"
										>
											<span v-if="coluna && coluna.binaria">{{
												itemTabela[coluna.campo] | transformaColunaBinaria
											}}</span>
											<span v-else-if="coluna && coluna.numerica">{{
												itemTabela[coluna.campo] | transformaColunaNumberica
											}}</span>
											<span v-else-if="coluna && coluna.data">{{
												itemTabela[coluna.campo] | transformaColunaData
											}}</span>
											<span v-else-if="coluna && coluna.telefone">{{
												formatPhoneNumber(itemTabela[coluna.campo])
											}}</span>
											<span v-else-if="coluna && coluna.data_hora">{{
												itemTabela[coluna.campo] | transformaColunaDataHora
											}}</span>
											<span v-else-if="coluna && coluna.porcentagem">{{
												itemTabela[coluna.campo] | transformaColunaPorcentagem
											}}</span>
											<span v-else-if="coluna && coluna.hora">{{
												itemTabela[coluna.campo] | transformaColunaHora
											}}</span>
											<span v-else-if="coluna && coluna.personalizado">{{
												coluna.callback(itemTabela[coluna.campo])
											}}</span>
											<span v-else>{{ itemTabela[coluna.campo] }}</span>
										</slot>
									</div>
								</td>
								<td
									v-if="
										exibeConcluir ||
										exibeEditar ||
										exibeVisualizarImpressao ||
										exibeParecer ||
										exibeExcluir ||
										exibeCancelar ||
										exibeAtualizar
									"
								>
									<div v-if="exibeConcluir" class="table-option">
										<slot
											:name="'campo-concluir'"
											:item="itemTabela"
											:index="indexItemTabela"
										>
											<a
												href="#"
												@click.prevent="clickConcluir(itemTabela)"
												class="tabela-ta-a"
											>
												<i class="fa icon-check tabela-td-i"></i>
											</a>
										</slot>
									</div>
									<div v-if="exibeEditar" class="table-option">
										<slot
											:name="'campo-editar'"
											:item="itemTabela"
											:index="indexItemTabela"
										>
											<a
												href="#"
												@click.prevent="clickEditar(itemTabela)"
												class="tabela-ta-a"
												v-tooltip="'Editar'"
											>
												<i class="fa icon-editar tabela-td-i"></i>
											</a>
										</slot>
									</div>
									<div v-if="exibeVisualizarImpressao" class="table-option">
										<a
											href="#"
											@click.prevent="clickVisualizarImpressao(itemTabela)"
											class="tabela-ta-a"
										>
											<i class="fa icon-vizualizar tabela-td-i"></i>
										</a>
									</div>
									<div v-if="exibeParecer" class="table-option">
										<slot
											:name="'campo-parecer'"
											:item="itemTabela"
											:index="indexItemTabela"
										>
											<a
												href="#"
												@click.prevent="clickParecer(itemTabela)"
												class="tabela-ta-a"
											>
												<i class="fa icon-editar tabela-td-i"></i>
											</a>
										</slot>
									</div>
									<div
										v-if="
											exibeExcluir &&
											(!exibeExcluirColuna ||
												itemTabela[exibeExcluirColuna] ==
													(exibeExcluirInverter ? '0' : '1'))
										"
										class="table-option"
									>
										<slot
											v-if="condicaoExcluir(itemTabela)"
											:name="'campo-excluir'"
											:item="itemTabela"
											:index="indexItemTabela"
										>
											<a
												href="#"
												@click.prevent="clickExcluir(itemTabela)"
												class="tabela-ta-a"
												v-tooltip="'Excluir'"
											>
												<i class="fa icon-lixeira tabela-td-i"></i>
											</a>
										</slot>
									</div>
									<div v-if="exibeCancelar" class="table-option">
										<slot
											:name="'campo-cancelar'"
											:item="itemTabela"
											:index="indexItemTabela"
										>
											<a
												href="#"
												@click.prevent="clickCancelar(itemTabela)"
												class="tabela-ta-a"
												v-tooltip="'Cancelar'"
											>
												<i class="fa icon-lixeira tabela-td-i"></i>
											</a>
										</slot>
									</div>
									<div v-if="exibeAtualizar" class="table-option">
										<slot
											:name="'campo-atualizar'"
											:item="itemTabela"
											:index="indexItemTabela"
										>
											<a
												href="#"
												@click.prevent="clickAtualizar(itemTabela)"
												class="tabela-ta-a"
												v-tooltip="'Atualizar'"
											>
												<i class="fa icon-editar tabela-td-i"></i>
											</a>
										</slot>
									</div>
									<div v-if="exibeDownload" class="table-option">
										<slot
											:name="'campo-atualizar'"
											:item="itemTabela"
											:index="indexItemTabela"
										>
											<a
												href="#"
												@click.prevent="clickDownload(itemTabela)"
												class="tabela-ta-a"
												v-tooltip="'Laudo de Calibração'"
											>
												<i class="fa icon-download-item tabela-td-i"></i>
											</a>
										</slot>
									</div>
									<div v-if="exibeCalibrar" class="table-option">
										<slot
											:name="'campo-atualizar'"
											:item="itemTabela"
											:index="indexItemTabela"
										>
											<a
												href="#"
												@click.prevent="clickCalibrar(itemTabela)"
												class="tabela-ta-a"
												v-tooltip="'Atualizar Calibração'"
											>
												<i
													class="fa icon-solicitacao_atualizar_status tabela-td-i"
												></i>
											</a>
										</slot>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<!-- Paginacao -->
		<div class="col-md-12 text-center">
			<paginacao
				@click-pagina="clickPagina"
				:total-page="numeroDePaginas"
				:current-page="this.paginacao.paginaAtual"
			></paginacao>
		</div>
	</div>
</template>

<script>
import formatPhoneNumber from '@/helpers/formatPhoneNumber.js'
import Paginacao from './paginacao.vue'
import SnakeToCamel from '@/helpers/snakeToCamel.js'

var accents = require('remove-accents')

export default {
	components: {Paginacao},
	props: {
		dadosTabela: {
			type: Array,
			default: () => []
		},

		colunasTabela: {
			type: Array,
			required: true
		},

		labelItem: {
			type: String,
			required: true
		},

		colunaDescricao: {
			type: String,
			required: true
		},

		colunasFiltro: {
			type: Array,
			required: false,
			default: () => []
		},

		exibeEditar: {
			type: Boolean,
			required: false,
			default: false
		},

		exibeVisualizarImpressao: {
			type: Boolean,
			required: false,
			default: false
		},

		exibeBusca: {
			type: Boolean,
			required: false,
			default: true
		},

		exibeConcluir: {
			type: Boolean,
			required: false,
			default: false
		},

		exibeParecer: {
			type: Boolean,
			required: false,
			default: false
		},

		exibeExcluir: {
			type: Boolean,
			required: false,
			default: false
		},

		exibeCancelar: {
			type: Boolean,
			required: false,
			default: false
		},

		exibeAtualizar: {
			type: Boolean,
			required: false,
			default: false
		},

		exibeDownload: {
			type: Boolean,
			required: false,
			default: false
		},

		exibeCalibrar: {
			type: Boolean,
			required: false,
			default: false
		},

		serverSide: {
			type: Boolean,
			default: false
		},

		rota: {
			type: String,
			default: ''
		},

		/* A busca avançada não funciona corretamente para o modo server-side, mas se caso essa funcionalidade for adicionada esse comentário deve ser removido! */
		usarBuscaAvancada: {
			type: Boolean,
			required: false,
			default: false
		},

		condicaoLinha: {
			type: Function,
			default: () => ({})
		},

		condicaoExcluir: {
			type: Function,
			default: () => true
		},

		exibeExcluirColuna: {
			type: Boolean,
			required: false,
			default: false
		},

		exibeExcluirInverter: {
			type: Boolean,
			required: false,
			default: false
		},

		exibeNovo: {
			type: [Boolean, String],
			default: false
		},

		textoNovo: {
			type: String,
			default: ''
		},

		sentidoPadrao: {
			type: Boolean,
			required: false,
			default: true
		}
	},

	data() {
		return {
			atualizaTabela: 0,
			busca: '',
			ordenacao: {
				coluna: '',
				sentidoCrescente: this.sentidoPadrao
			},

			paginacao: {
				paginaAtual: 1,
				resultadosPorPagina: 10
			},

			filtros: {},
			colunasFiltroServe: null,

			dados: [],
			paginate: {},
			timeBusca: null,
			filtrosServeSideDebounce: null
		}
	},

	computed: {
		colunasFiltroFormated() {
			if (this.serverSide) {
				return this.colunasFiltroServe
			} else {
				let colunas = {}
				this.colunasFiltro.forEach((coluna) => {
					const gera_filtro = coluna?.gera_filtro
					if (!gera_filtro) {
						colunas[coluna] = this.valoresColunas[coluna]
						return
					}
					colunas[coluna.nome] = gera_filtro(this.valoresColunas)
				})
				return colunas
			}
		},

		numeroDePaginas() {
			if (this.serverSide) {
				return this.paginacao.paginas
			} else {
				return Math.ceil(
					this.dadosTabelaFiltrados.length / this.paginacao.resultadosPorPagina
				)
			}
		},

		dadosTabelaFiltrados() {
			let dadosTabela = this.dadosTabela.map((itemTabela) => {
				return Object.assign({}, itemTabela)
			})

			if (Object.keys(this.filtros).length) {
				dadosTabela = this.aplicaFiltros(dadosTabela)
			}

			if (this.busca) {
				dadosTabela = this.aplicaBusca(dadosTabela)
			}

			if (this.ordenacao.coluna) {
				dadosTabela = this.ordenaTabela(dadosTabela)
			}

			this.$emit('dados-filtrados', dadosTabela)

			return dadosTabela
		},

		dadosTabelaPaginaAtual() {
			if (this.serverSide) {
				if (parseInt(this.paginacao.paginaAtual) > this.paginacao.paginas) {
					this.paginacao.paginaAtual = 1
					this.carregarTabelaServer({
						params: {
							search: this.busca,
							page: this.paginacao.paginaAtual,
							order_by: this.ordenacao.coluna,
							sort: this.ordenacao.sentidoCrescente ? 'ASC' : 'DESC',
							filtros: JSON.stringify(this.filtros)
						}
					})
				}
				return this.dados
			} else {
				return this.dadosPaginaAtual(this.dadosTabelaFiltrados)
			}
		},

		exibirFiltro() {
			return this.colunasFiltro.length > 0 || this.colunasFiltroServe
		},

		valoresColunas() {
			let valores = {}

			this.colunasTabela.forEach((coluna) => {
				let valoresColuna = this.dadosTabela.map((itemTabela) => {
					return String(itemTabela[coluna.campo]).toUpperCase()
				})

				valores[coluna.campo] = [...new Set(valoresColuna)]
			})

			return valores
		},

		filtroTodosAtivo() {
			return Object.keys(this.filtros).length == 0
		},

		inputBuscaPlaceholder() {
			return this.usarBuscaAvancada
				? this._traducao('global', 'digiteParaRealizarUmaBuscaAvancada')
				: this._traducao('global', 'buscar')
		}
	},

	filters: {
		transformaColunaBinaria(value) {
			if (!isNaN(value)) {
				value = Number(value)
			}

			if (value) {
				return 'Sim'
			}
			return 'Não'
		},
		transformaColunaNumberica(value) {
			return Number(value)
		},
		transformaColunaData(value) {
			const data = new moment(value, 'YYYY-MM-DD')
			return data.isValid() ? data.format('DD/MM/YYYY') : ''
		},
		transformaColunaDataHora(value) {
			const data = new moment(value, 'YYYY-MM-DD HH:mm:ss')
			return data.isValid() ? data.format('DD/MM/YYYY HH:mm') : ''
		},
		transformaColunaHora(value) {
			const data = new moment(value, 'HH:mm')
			return data.isValid() ? data.format('HH:mm') : ''
		},
		transformaColunaPorcentagem(value) {
			if (!value) {
				return 'N/A'
			}
			return `${value}%`
		}
	},

	mounted() {
		if (this.serverSide && this.rota !== '') {
			this.carregarTabelaServer()
		}
	},

	methods: {
		formatPhoneNumber,
		filtrosServeSide() {
			clearTimeout(this.filtrosServeSideDebounce)
			this.filtrosServeSideDebounce = setTimeout(() => {
				if (this.serverSide) {
					this.carregarTabelaServer({
						params: {
							search: this.busca,
							page: this.paginacao.paginaAtual,
							order_by: this.ordenacao.coluna,
							sort: this.ordenacao.sentidoCrescente ? 'ASC' : 'DESC',
							filtros: JSON.stringify(this.filtros)
						}
					})
				}
			}, 100)
		},
		buscaServeSide() {
			if (this.serverSide) {
				clearTimeout(this.timeBusca)
				this.timeBusca = setTimeout(() => {
					this.filtrosServeSide()
				}, 400)
			}
		},
		// Metodos Filtro
		carregarTabelaServer(options = {}) {
			this.carregando = true
			this._axios(this.rota, 'get', {
				...options,
				callback: (retorno) => {
					if (retorno._request && retorno._status) {
						const {lista, pagination, filters} = retorno
						this.dados = lista
						this.paginacao = {
							paginaAtual: pagination.page,
							resultadosPorPagina: pagination.per_page,
							paginas: pagination.pages,
							proxima: pagination.next,
							anterior: pagination.previous,
							atual: pagination.current,
							total: pagination.total
						}
						this.colunasFiltroServe = filters
					}
				},
				finally: () => {
					this.carregando = false
				}
			})
		},

		clickFiltroTodos() {
			this.filtros = {}
		},

		posicaoFiltro(colunaFiltro, valorFiltro) {
			if (!(colunaFiltro in this.filtros)) {
				return -1
			}

			return this.filtros[colunaFiltro].findIndex((filtro) => {
				return filtro == valorFiltro
			})
		},

		clickFiltro(colunaFiltro, valorFiltro) {
			let indexFiltro = this.posicaoFiltro(colunaFiltro, valorFiltro)

			if (indexFiltro >= 0) {
				this.removeFiltro(colunaFiltro, indexFiltro)
			} else {
				if (!(colunaFiltro in this.filtros)) {
					this.$set(this.filtros, colunaFiltro, [])
				}
				this.filtros[colunaFiltro].push(valorFiltro)
			}

			this.filtrosServeSide()
		},

		filtroAtivo(colunaFiltro, valorFiltro) {
			return this.posicaoFiltro(colunaFiltro, valorFiltro) >= 0
		},

		removeFiltro(colunaFiltro, indexFiltro) {
			this.filtros[colunaFiltro].splice(indexFiltro, 1)
			this.filtrosServeSide()
		},

		// Metodos Tabela

		ordenaTabela(dadosTabela) {
			const coluna = this.colunasTabela.find((coluna) => {
				return coluna.campo === this.ordenacao.coluna
			})
			return dadosTabela.sort((itemTabela1, itemTabela2) => {
				let valorItem1 = itemTabela1[this.ordenacao.coluna]
				let valorItem2 = itemTabela2[this.ordenacao.coluna]

				if (typeof valorItem1 === 'string' && typeof valorItem2 === 'string') {
					valorItem1 = valorItem1.toLowerCase()
					valorItem2 = valorItem2.toLowerCase()
				}

				if (coluna.numerica) {
					valorItem1 = Number(valorItem1)
					valorItem2 = Number(valorItem2)
				}

				let resultado = 0
				if (valorItem1 > valorItem2) {
					resultado = 1
				} else if (valorItem1 < valorItem2) {
					resultado = -1
				}

				return this.ordenacao.sentidoCrescente ? resultado : -resultado
			})
		},

		aplicaFiltros(dadosTabela) {
			return dadosTabela.filter((itemTabela) => {
				for (let [coluna, filtrosColuna] of Object.entries(this.filtros)) {
					if (!filtrosColuna.length) {
						continue
					}
					let passouColuna = false
					const filtro_avancado = this.colunasFiltro.find(
						(item) => item.nome == coluna
					)?.processa_filtro
					if (filtro_avancado) {
						passouColuna = filtrosColuna.some((valorFiltro) => {
							return filtro_avancado(itemTabela, valorFiltro)
						})
					} else {
						passouColuna = filtrosColuna.some((valorFiltro) => {
							return (
								String(itemTabela[coluna]).toUpperCase() ==
								String(valorFiltro).toUpperCase()
							)
						})
					}

					if (!passouColuna) {
						return false
					}
				}
				return true
			})
		},

		checkIfItemIsEqualToBusca(item) {
			const itemLowerCaseAndNoAccents = accents.remove(item).toLowerCase()
			const buscaLowerCaseAndNoAccents = accents
				.remove(this.busca)
				.toLowerCase()
			return itemLowerCaseAndNoAccents.indexOf(buscaLowerCaseAndNoAccents) > -1
		},

		checkPropsByTypes(prop) {
			if (typeof prop === 'string' || typeof prop === 'number') {
				return this.checkIfItemIsEqualToBusca(prop.toString())
			} else if (typeof prop === 'object' && Array.isArray(prop)) {
				return prop.some((value) => this.checkPropsByTypes(value))
			} else if (typeof prop === 'object' && !!prop) {
				return Object.entries(prop).some(([key, value]) =>
					this.checkPropsByTypes(value)
				)
			} else {
				return false
			}
		},

		buscaAvancada(dadosTabela) {
			return dadosTabela.filter((itemTabela) =>
				this.checkPropsByTypes(itemTabela)
			)
		},

		buscaPorColunasTabela(dadosTabela) {
			return dadosTabela.filter((itemTabela) =>
				this.colunasTabela.some((colunaTabela) =>
					this.checkIfItemIsEqualToBusca(itemTabela[colunaTabela.campo] + '')
				)
			)
		},

		aplicaBusca(dadosTabela) {
			if (this.usarBuscaAvancada) {
				return this.buscaAvancada(dadosTabela)
			} else {
				return this.buscaPorColunasTabela(dadosTabela)
			}
		},

		dadosPaginaAtual(dadosTabela) {
			let comeco =
				this.paginacao.resultadosPorPagina * (this.paginacao.paginaAtual - 1)
			let final =
				this.paginacao.resultadosPorPagina * this.paginacao.paginaAtual
			if (comeco > dadosTabela.length) {
				this.paginacao.paginaAtual = 1
				comeco =
					this.paginacao.resultadosPorPagina * (this.paginacao.paginaAtual - 1)
				final = this.paginacao.resultadosPorPagina * this.paginacao.paginaAtual
			}
			return dadosTabela.slice(comeco, final)
		},

		clickOrdenar(coluna) {
			if (this.ordenacao.coluna == coluna) {
				this.ordenacao.sentidoCrescente = !this.ordenacao.sentidoCrescente
			} else {
				this.ordenacao.coluna = coluna
				this.ordenacao.sentidoCrescente = true
			}
			this.filtrosServeSide()
			this.atualizaTabela++
		},

		clickConcluir(itemTabela) {
			this.$emit('click-concluir', itemTabela)
		},

		clickEditar(itemTabela) {
			this.$emit('click-editar', itemTabela)
		},

		clickNovo() {
			this.$emit('click-novo')
		},

		clickVisualizarImpressao(itemTabela) {
			this.$emit('click-visualizar-impressao', itemTabela)
		},

		clickParecer(itemTabela) {
			this.$emit('click-parecer', itemTabela)
		},

		clickExcluir(itemTabela) {
			let descricao = itemTabela[this.colunaDescricao]

			let texto = `<h3> ${this._traducao('global', 'desejaExcluir')} ${
				this.labelItem
			}?
							<br/>
							<span class='text-danger'>  ${descricao}</span>
						</h3>`
			this._modalExcluir(
				(retorno) => {
					if (retorno.excluir) {
						if (this.serverSide && this.rota !== '') {
							this.$emit('click-excluir', retorno.obj, this.buscaServeSide)
						} else {
							this.$emit('click-excluir', retorno.obj)
						}
					}
				},
				itemTabela,
				texto,
				this._traducao('global', 'excluir').toUpperCase()
			)
		},

		clickCancelar(itemTabela) {
			let descricao = itemTabela[this.colunaDescricao]

			let texto = `<h3> ${this._traducao('global', 'cancelar')} ${
				this.labelItem
			}?
							<br/>
							<span class='text-danger'>  ${descricao}</span>
						</h3>`
			this._modalExcluir(
				(retorno) => {
					if (retorno.excluir) {
						if (this.serverSide && this.rota !== '') {
							this.$emit('click-cancelar', retorno.obj, this.buscaServeSide)
						} else {
							this.$emit('click-excluir', retorno.obj)
						}
					}
				},
				itemTabela,
				texto,
				this._traducao('global', 'cancelar').toUpperCase()
			)
		},

		clickAtualizar(itemTabela) {
			this.$emit('click-atualizar', itemTabela)
		},

		clickDownload(itemTabela) {
			this.$emit('click-download', itemTabela)
		},

		clickCalibrar(itemTabela) {
			this.$emit('click-calibrar', itemTabela)
		},

		getColuna(campoColuna) {
			const coluna = this.colunasTabela.find((colunaTabela) => {
				return colunaTabela.campo == campoColuna
			})
			if (coluna) {
				return coluna
			}
			return null
		},

		labelColuna(campoColuna) {
			const coluna = this.colunasTabela.find((colunaTabela) => {
				return colunaTabela.campo == campoColuna
			})?.nome
			if (coluna) {
				return coluna
			} else {
				const colunaCamel = SnakeToCamel(campoColuna)
				const colunaTraduzida = this._traducao('global', colunaCamel)
				return colunaTraduzida === 'undefined' ? campoColuna : colunaTraduzida
			}
		},

		// Metodos Paginacao

		clickPaginaAnterior() {
			if (this.paginacao.paginaAtual > 1) {
				this.paginacao.paginaAtual--
				this.filtrosServeSide()

				this.atualizaTabela++
			}
		},

		clickProximaPagina() {
			if (this.paginacao.paginaAtual < this.numeroDePaginas) {
				this.paginacao.paginaAtual++
				this.filtrosServeSide()

				this.atualizaTabela++
			}
		},

		clickPagina(pagina) {
			this.paginacao.paginaAtual = pagina
			this.filtrosServeSide()
			this.atualizaTabela++
		}
	},

	watch: {
		busca(val, oldVal) {
			if (val != oldVal) this.atualizaTabela++
		}
	}
}
</script>

<style scoped>
.paginacao-margin {
	margin: 0px;
}

.tabela-td-i {
	font-size: 20px;
}

.tabela-ta-a {
	display: block;
	margin-left: 6px;
	margin-right: 6px;
}

.tabela-margin {
	margin-top: 20px;
}

.tabela-ul {
	overflow: auto;
}

.tabela-margin-top {
	margin-top: 4px;
}
.table-option {
	display: inline-block;
}

.label-filtro-tabela {
	font-size: 11px;
	color: #fff;
	border-radius: 2px;
	padding: 4px 6px;
	margin-bottom: 8px;
	cursor: pointer;
}

.tag-filtro {
	max-width: 120px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>